import { render, staticRenderFns } from "./RateLimiter.vue?vue&type=template&id=4429ff43&"
import script from "./RateLimiter.vue?vue&type=script&lang=ts&"
export * from "./RateLimiter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports